import { render, staticRenderFns } from "./ExternalAccounts.vue?vue&type=template&id=bda9d77c&"
import script from "./ExternalAccounts.vue?vue&type=script&lang=js&"
export * from "./ExternalAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports